<div class="d-flex flex-column h-100">
  <app-header></app-header>
  <div role="main">
    <router-outlet></router-outlet>
  </div>
  <!-- Footer buttons container can go here -->
  <div class="footer-buttons-container">
    <!-- This is where you can add your sticky buttons that appear above the footer -->
  </div>
  <app-footer></app-footer>
</div>